module.exports = __webpack_public_path__ + "img/346e39a.png";